import { CircularProgress, Stack, styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'

export function PendingImportMessage({ message }: { message: string }) {
    return (
        <Stack width="100%" direction="row" alignItems="center" gap={tokens.SizingSpacing200}>
            <Typography color={tokens.ColorTextDefault} variant="textS">
                {message}
            </Typography>
            <InlineProgressContainer>
                <CircularProgress size={tokens.SizingIconS} thickness={4} sx={{ position: 'relative', top: 0, left: 0 }} />
            </InlineProgressContainer>
        </Stack>
    )
}

const InlineProgressContainer = styled('span')(() => ({
    width: tokens.SizingIconS,
    height: tokens.SizingIconS,
    display: 'inline-flex',
    flexShrink: 0,
    overflow: 'hidden',
}))
